import React from 'react';
import { getSharedPremiumResource, PremiumSharedResource } from '../premium-api';
import { useWillMount } from '../react-utils/Hooks';
import { PremiumEssentialsRef } from './PremiumEssentialsApi';
const PremiumEssentialsContext = getSharedPremiumResource(PremiumSharedResource.EssentialsContext, () => {
  return /*#__PURE__*/React.createContext(null);
});
const NoopErrorBoundary = _ref => {
  let {
    children
  } = _ref;
  return /*#__PURE__*/React.createElement(React.Fragment, null, children);
};
export const PremiumEssentialsProvider = _ref2 => {
  let {
    children,
    ErrorBoundary,
    hasErrorBoundary: hasErrorBoundaryFromProps,
    ...props
  } = _ref2;
  const existingValues = React.useContext(PremiumEssentialsContext);
  const hasErrorBoundary = hasErrorBoundaryFromProps || !!ErrorBoundary;
  const ErrorBoundary_ = ErrorBoundary != null ? ErrorBoundary : NoopErrorBoundary;
  const {
    errorBoundaryProps
  } = props;
  const values = {
    ...existingValues,
    ...props,
    hasErrorBoundary
  };
  useWillMount(() => {
    const prevInitialized = PremiumEssentialsRef.initialized;
    PremiumEssentialsRef.essentials = {
      ...values
    };
    PremiumEssentialsRef.initialized = true;
    return () => {
      PremiumEssentialsRef.essentials = {
        ...existingValues
      };
      PremiumEssentialsRef.initialized = prevInitialized;
    };
  }, []);
  return /*#__PURE__*/React.createElement(PremiumEssentialsContext.Provider, {
    value: values
  }, /*#__PURE__*/React.createElement(ErrorBoundary_, errorBoundaryProps, children));
};
export const usePremiumEssentialsContext = function (throwOnNoContext) {
  if (throwOnNoContext === void 0) {
    throwOnNoContext = true;
  }
  const values = React.useContext(PremiumEssentialsContext);
  if (!values && throwOnNoContext) {
    throw new Error('<PremiumEssentialsProvider was not initialized, please add this provider in your root component');
  }
  return values;
};
export const usePremiumI18n = () => {
  const {
    i18n,
    Trans
  } = usePremiumEssentialsContext();
  if (!i18n || !Trans) {
    throw new Error('<PremiumEssentialsProvider/> was not initialized with valid i18n / Trans, please add these values to the provider');
  }
  return {
    i18n,
    Trans,
    locale: i18n.language
  };
};
//# sourceMappingURL=PremiumEssentialsProvider.js.map